import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../../components/Converter";
import PlusIcon from "../../../../../components/Icons/PlusIcon";
import RenderFor, { BM_TYP } from "../../../../../components/RenderFor";
import { RowBody } from "../../../../../components/RowValue/RowBody";

function DispersionCoefficient({ value, showModal }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("lvText.positionTestLoads.dispersionCoefficient")}</p>}
      indicesValue={
        <span>
          ξ<sub>1</sub>
        </span>
      }
      inputValue={<span className="input">{ConvertToString(value, 2)}</span>}
      formulaValue={
        <RenderFor types={[BM_TYP.EUROCODE_7, BM_TYP.GERMANY]}>
          <span className="input--formula" onClick={() => showModal(true)}>
            <PlusIcon />
          </span>
        </RenderFor>
      }
    />
  );
}

export default DispersionCoefficient;
